export default __webpack_public_path__ + "static/media/gummies@3x.71df6fdf.png";